import {
  Button,
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { FC, useEffect, useState } from 'react';
import CountUp from 'react-countup';

import Countdown from '../../components/Countdown';
import { getDisplayAmount } from '../../lib/accounts';
import { Raffle } from '../../lib/types';
import useCommonStyles from '../../assets/styles';
import { useStyles } from './styles';
import { useViewport } from '../../hooks/useViewport';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';

type UserTicketsDialogProps = DialogProps & {
  setOpen: (isOpen: boolean) => void;
  userTickets?: number[];
};

const UserTicketsDialog: FC<UserTicketsDialogProps> = ({
  setOpen,
  userTickets,
  ...props
}) => {
  return (
    <Dialog {...props} onClose={() => setOpen(false)} fullWidth={true}>
      <DialogTitle>My tickets</DialogTitle>
      <DialogContent>
        {userTickets?.map((userTicket) => (
          <div key={userTicket}>#{userTicket + 1}</div>
        ))}
      </DialogContent>
    </Dialog>
  );
};

interface RaffleInfoSectionProps {
  raffle: Raffle;
  userConnected: boolean;
  userTickets?: number[];
}

const RaffleInfoSection: FC<RaffleInfoSectionProps> = ({
  userConnected,
  raffle,
  userTickets,
}) => {
  const { device } = useViewport();
  const classes = { ...useCommonStyles(), ...(useStyles({ device }) as any) };
  const [open, setOpen] = useState(false);

  const [nftTokenAmount, setNftTokenAmount] = useState<number | null>(null);

  useEffect(() => {
    // console.log()
    getTokenData();
  }, []);
  async function getTokenData() {
    await fetch(
      `https://price.jup.ag/v1/price?id=${raffle.proceeds.mint.symbol}&vsToken=SOL`
    )
      .then(async (res: any) => {
        const temp = await res.json();
        
        // console.log(temp, 'resss');
        // console.log(temp, 'token data');
        // console.log(
        //   temp.data.price * raffle.entrantsCap*(raffle.proceeds.ticketPrice.toNumber()/LAMPORTS_PER_SOL),
        //   'tt'
        // );
        if(temp.data?.price)
        setNftTokenAmount(
          temp.data.price *
            raffle.entrantsCap *
            (raffle.proceeds.ticketPrice.toNumber() / Math.pow(10, raffle?.proceeds?.mint?.decimals||9))
          );
        else
          setNftTokenAmount(null);
      })
      .catch((err) => {
        console.log('err getting token price');
        setNftTokenAmount(null);
      });
  }

  return (
    <div className={classes.root + ' bg-green-00'}>
      <div className={classes.ticketsSection}>
        <div
          className={
            ' border-dashed border-r-2  w-6/12 border-brand_smooth_yellow'
          }
        >
          <p className={`${classes.cardSubTitle} GTWalsheimProRegular`}>
            Tickets Sold
          </p>
          <div className={`${classes.cardData} primary_font text-xl flex`}>
            <CountUp
              start={0}
              end={raffle.totalTickets}
              delay={0}
              duration={0.8}
              preserveValue
              useEasing
            >
              {({ countUpRef }) => (
                <p
                  className="GTWalsheimProBold text-brand_secondary"
                  ref={countUpRef}
                />
              )}
            </CountUp>
            <p className={classes.separator + ' text-brand_secondary'}>/</p>
            <p className="GTWalsheimProBold">{`${raffle.entrantsCap}`}</p>
          </div>
        </div>
        <div className={classes.ticketPrice + ' text-center'}>
          <p className={`${classes.cardSubTitle} GTWalsheimProRegular`}>
            Ticket Price
          </p>
          <p className={`${classes.cardData} primary_font text-xl`}>
            {`${getDisplayAmount(
              raffle.proceeds.ticketPrice,
              raffle.proceeds.mint
            )} ${raffle.proceeds.mint.symbol}`}
          </p>
        </div>
      </div>
      {userConnected && (
        <div className={classes.ticketsSection + ' bg-blue-00 pt-6'}>
          {!raffle.isEnded && (
            <>
              <div className="border-dashed w-6/12 border-r-2 border-brand_smooth_yellow">
                <p className={`${classes.cardSubTitle} GTWalsheimProRegular`}>
                  My tickets
                </p>
                <div className={`${classes.cardData} primary_font text-xl`}>
                  <CountUp
                    start={0}
                    end={userTickets?.length ?? 0}
                    delay={0}
                    duration={0.8}
                    preserveValue
                    useEasing
                  >
                    {({ countUpRef }) => (
                      <p className="text-brand_accent" ref={countUpRef} />
                    )}
                  </CountUp>
                </div>
              </div>

              {nftTokenAmount && nftTokenAmount > 0 && (
                <div className={classes.ticketPrice + ' text-center'}>
                  <p className={`${classes.cardSubTitle} GTWalsheimProRegular`}>
                    Total Ticket Value
                  </p>
                  <p className={`${classes.cardData} primary_font text-xl`}>
                    {`${nftTokenAmount.toFixed(2)} SOL`}
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default RaffleInfoSection;
